<template>
    <ion-chip :title="attachment.filename"
              @click="attachmentClick"
              outline
              color="primary"
              class="file">
        <ion-label class="ion-text-nowrap">
            <ion-icon ios='attach' md="attach" slot="start"></ion-icon>

            <span>{{ attachment.short_name }}</span>

            <ion-badge slot="end" v-if="!$root.isMobileOrSmall">{{ attachment.readable_size }}</ion-badge>
        </ion-label>
    </ion-chip>
</template>

<script>
    export default {
        name: "IncomingMailAttachment",
        props: {
            attachment: {type: Object},
        },
        methods: {
            attachmentClick() {
                alert('Het downloaden van bijlages van binnenkomende mail wordt binnenkort beschikbaar');
            },
        },
    }
</script>

<style scoped lang="scss">
    ion-label {
        h1, h2, h3, h4 {
            text-overflow: inherit;
            overflow: inherit;
        }
    }

    .file {
        max-width: 98%;
        flex: 0 0 auto;

        ion-icon {
            margin-right: 3px;
            font-size: 18px;
            min-width: 16px;
        }

        ion-label {
            display: flex;
            align-items: center;
        }

        ion-badge {
            margin-left: 8px;
            font-size: 11px;
        }
    }
</style>
